const urlParams = new URL(window.location.href).searchParams
const platform = urlParams.get("platform") === "mobile" ? "mobile" : "web"

export default {
  platform,
  isMobile: () => {
    return platform === "mobile"
  },
  isDesktop: () => {
    return platform !== "mobile"
  }
}
